import { styled } from '@/stitches.config';

import { Box } from '@base-app';

export const StyledBranchTreeItem = styled(Box, {
  display: 'flex',
  height: '$8',
  variants: {
    last: {
      false: {
        position: 'relative',
      },
    },
  },
});

export const StyledBranchTreeStart = styled(StyledBranchTreeItem, {
  height: '$5',
  position: 'relative',
});

export const StyledTrunk = styled(Box, {
  alignSelf: 'self-start',
  width: '1px',
  position: 'absolute',
  bottom: '0',
  left: '0',
  height: '100%',
  borderLeftWidth: '$1',
  borderLeftColor: '$coolGray200',
  borderLeftStyle: 'solid',
});

export const StyledBranch = styled(Box, {
  borderLeftWidth: '$1',
  borderLeftColor: '$coolGray200',
  borderLeftStyle: 'solid',
  borderBottomWidth: '$1',
  borderBottomColor: '$coolGray200',
  borderBottomStyle: 'solid',
  borderBottomLeftRadius: '$4',
  width: '$10',
  height: '$3',
  marginRight: '$4',
});

export const StyledBranchTreeItemLabel = styled(Box, {
  color: '$darkBlue400',
  fontWeight: '$regular',
  fontSize: '$normal',
  lineHeight: '$6',
  marginRight: '$2',
});

export const StyledBranchTreeItemValue = styled(Box, {
  color: '$darkBlue400',
  fontWeight: '$bold',
  fontSize: '$normal',
  lineHeight: '$6',
});
